import Vue from 'vue';
import VueNotification from 'vue-notification';

export default {
    init() {
        Vue.use(VueNotification);
    },
};
